import React, { useState } from "react";
import UploadFile from "./MakerProgressBar/UploadFile";
import ValidationResults from "./MakerProgressBar/ValidationResults";
import Confirmation from "./Confirmation";


function BulkUpload({ handleTabChange, selectedRequest, isFromMyRequest, setSelectedSR, refreshHistory, rowData }) {
  
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [validationData, setValidationData] = useState(null);
  const [confirmationData, setConfirmationData] = useState({
    submittedCount: 0,
    draftCount: 0,
    generatedSrIds: [],
  });

  const isReadOnlyRequest =
  isFromMyRequest &&
  ["approved", "rejected"].includes(
    selectedRequest?.status?.toLowerCase()
  );

const [step, setStep] = useState(isReadOnlyRequest ? 2 : 1);

  const handleFileUpload = (fileData) => {
    setValidationData(fileData)
    setStep(2);
  };

  return (
    <div className="new-upload">
      {!showConfirmation && !isReadOnlyRequest &&
        <div className="progress-bar">
          <div className={`progress-step ${step > 1 ? "completed" : ""} ${step === 1 ? "active" : ""}`}>
            <div className={`${step === 1 ? "pending-state" : ""}`}>
              <span className="circle">1</span>
            </div>
            <span className="label">Upload File</span>
            </div>
            <div className={`progress-line ${step > 1 ? "active" : ""}`}></div>
            <div className={`progress-step ${step > 2 ? "completed" : ""} ${step === 2 ? "active" : ""}`}>
              <div className={`${step === 2 ? "pending-state" : ""}`}>
                <span className="circle">2</span>
              </div>
              <span className="label">Validation Results</span>
            </div>
          </div>
        }

      <div className="wrap-all-tabs">

        {showConfirmation ? (
          <Confirmation
            confirmationData={confirmationData}
            // setActiveTab={setActiveTab}
            handleTabChange={handleTabChange}
            onNewUpload={() => {
              setShowConfirmation(false);
              handleTabChange("newMap");
            }}
          />
        ) : (
          <>
            {step === 1 && (
              <UploadFile
                onUpload={handleFileUpload}
                selectedRequest={selectedRequest}
                isFromMyRequest={isFromMyRequest}
                rowData={rowData}
              />
            )}

            {step === 2 && (
              <ValidationResults
                validationData={validationData}
                setConfirmationData={setConfirmationData}
                onNext={() => setShowConfirmation(true)}
                selectedRequest={selectedRequest}
                refreshHistory={refreshHistory}
                isFromMyRequest={isFromMyRequest}
                setSelectedSR={setSelectedSR}
                isReadOnly={isReadOnlyRequest}
              />
            )}
          </>
        )}

      </div>
    </div>
  );
}

export default BulkUpload;
